// extracted by mini-css-extract-plugin
export default {"example":"style_example__KPK2f"};